/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function LanguagesEditViewController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $route: JS5Object,
    $routeParams: JS5Object,
    $timeout: JS5Function,
    uiGridConstants: JS5Object,
    BreadcrumbService: JS5Object,
    LanguagesService: JS5Object,
    ModalService: JS5Object,
    PermissionsService: JS5Object,
    SidebarService: JS5Object,
    UtilsService: JS5Object,
) {
    this.editData = {};
    const getData = () => {
        this.loadingIndicator.show = true;
        LanguagesService.getLanguage($routeParams.id).then((language: JS5Object) => {
            LanguagesService.originalEditData = _.cloneDeep(language);
            this.editData = language;
            this.gridOptions.data = _.toArray(language.aliases);
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };


    const saveHandler = () => {
        _.set(this.editData, 'aliases', _.toArray(this.gridOptions.data));
        this.editData.iso2Code = _.toUpper(this.editData.iso2Code);
        _.forEach(_.get(this.editData, 'aliases'), (alias: JS5Object) => {
            _.unset(alias, 'edited');
        });
        this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewLanguage();
        }
        else {
            updateLanguage();
        }
    };
    const updateLanguage = () => {
        LanguagesService.updateLanguage(this.editData).then((language: JS5Object) => {
            LanguagesService.originalEditData = _.cloneDeep(language);
            this.editData = language;
            this.editorForm.$setPristine();
            this.gridApi.selection.clearSelectedRows();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };
    const saveNewLanguage = () => {
        LanguagesService.createLanguage(this.editData).then((language: JS5Object) => {
            $route.updateParams({id: language.id});
            this.gridApi.selection.clearSelectedRows();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const addAliasHandler = (selectedPartners: Array<JS5Object>) => {
        let originalGridDataSize = _.size(this.gridOptions.data);
        let selectedAliases = new Array<JS5Object>();
        selectedPartners.forEach((selectedPartner: JS5Object) => {
            selectedAliases.push({
                alias: '',
                edited: true,
                partner: selectedPartner
            });
        });
        this.gridOptions.data = _.unionBy(_.toArray(this.gridOptions.data), selectedAliases, 'partner.id');
        if (_.size(this.gridOptions.data) > originalGridDataSize) {
            this.editorForm.$setDirty();
        }
        this.loadingIndicator.show = false;
    };

    this.removeAlias = () => {
        const selectedAliases = this.gridApi.selection.getSelectedRows();
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to remove the selected alias(es)?',
            pullCancelLeft: true,
            title: 'Remove Alias(es)',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, () => {


            this.gridOptions.data = _.differenceBy(this.gridOptions.data, selectedAliases, 'partner.id');
            this.editorForm.$setDirty();
        });
    };
    this.addAlias = () => {
        ModalService.showAliasesModal(addAliasHandler);
    };

    this.validateInput = ($event: JS5Object, currentValue: JS5Object, regexString: string) => {
        UtilsService.inputValidatorByRegExpString($event, currentValue, regexString);
    };

    const columnDefinitions = [
        {
            field: 'partner.name',
            displayName: 'Partner (Read-Only)',
            cellEditableCondition: false,
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'alias',
            displayName: 'Alias (Double Click to Edit)',
            cellTemplate: 'components/visual/grid/inline-edit-template.html'
        }
    ];

    this.gridOptions = {
        enableRowHeaderSelection: true,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: false,
        enableCellEditOnFocus: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: true,
        columnDefs: columnDefinitions,
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
            this.gridApi.edit.on.afterCellEdit(
                null,
                (rowEntity: JS5Object, colDef: JS5Object, newValue: any, oldValue: any) => {
                    if (newValue !== oldValue) {
                        _.set(rowEntity, 'edited', true);
                    }
                });
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };


    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => !_.get(this.editorForm, '$pristine')
                && _.size(_.get(this.editData, 'name'))
                && _.size(_.get(this.editData, 'iso2Code')) === 2
                && _.every(this.gridOptions.data, (gridItem: JS5Object) => {
                    return _.size(gridItem.alias);
                }),
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: () => {
                this.editData = _.cloneDeep(LanguagesService.originalEditData);
                this.gridOptions.data = _.get(this.editData, 'aliases');
                this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: () => !_.get(this.editorForm, '$dirty'),
            onClick: () => $location.url(`/system/properties/search`).search({tab: 'Languages'})
        }
    ];


    this.$onInit = () => {
        SidebarService.editService = LanguagesService;
        this.isAdmin = PermissionsService.isAdmin();
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        if (this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit Language',
                        location: '/system/properties/search',
                        params: {tab: 'Languages'}
                    });
                }
                getData();
            } else {
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Language',
                    location: '/system/properties/search',
                    params: {tab: 'Languages'}
                });
            }

        } else {
            $location.url('/login');
        }
    };

    this.$onDestroy = () => {
        LanguagesService.originalEditData = null;
        LanguagesService.viewData = null;
    };

    this.$postLink = () => {
        $timeout(() => {
            LanguagesService.editorForm = this.editorForm;
            BreadcrumbService.editService = LanguagesService;
        });
    };
}


angular.module('prism-ui.languages').component('languagesEditView', {
    templateUrl: 'system/languages/editor/languages-edit-view-template.html',
    controller: LanguagesEditViewController,
    bindings: {
    }
});
